import React from "react";
import { Modal } from "react-bootstrap";

import { Typography } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/fr";

// Configuration de dayjs en français
dayjs.locale("fr");

const DesactiveAssureModal = ({
  show,
  handleClose,
  handleConfirm,
  assure,
  message,
}) => {
  if (!assure) {
    return null;
  }
  const { nom } = assure;
  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton sx={{ borderBottom: "none", pb: 0 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Desactive l'assure <span>{nom}</span>
        </Typography>
      </Modal.Header>

      <Modal.Body>
        {" "}
        <p className="text-warning h5 "> {message}</p>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => handleClose()}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            handleConfirm();
            handleClose();
          }}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesactiveAssureModal;
